import React from 'react'
import { ListGroup, ListGroupItemText, ListGroupItemHeading, Col, Row, Card } from 'shards-react'
import './sales-report.css'
import ChartComponent from './ChartComponent'
import ActivityIndicator from '../activity-indicator/ActivityIndicator'
import AxiosService from '../../services/axios-service/AxiosService'

export default class SalesReport extends React.Component {
    constructor() {
        super()
        this.state = {
            sales: [],
            labels: [],
            dataSetsBarChart: [],
            dataSetsLineChart: [],
            isFetching: false,
        }
    }

    componentDidMount = async () => {
        this.setState({ isFetching: true })
        try {
            const result = await AxiosService.httpGet('https://private-c335f6-salesreport1.apiary-mock.com/questions#')
            const dataSet = this.sortData(result.data)
            const dataBarChartList = [dataSet.salesQuantity, dataSet.soldItemsQuantity]
            const labelsBarChart = ['Quantidade de Vendas', 'Quantidade de itens vendidos']
            const backgroundColorBarChartList = ['#EF3867', '#848484']

            const labelsLineChart = ['Valor Mensal de Vendas(R$)']
            const backgroundColorLineList = ['#EF3867']
            const dataSetsBarChart = this.buildDataSets(labelsBarChart, dataBarChartList, backgroundColorBarChartList)
            const dataSetsLineChart = this.buildDataSets(labelsLineChart, dataSet.totals, backgroundColorLineList)
            this.setState({
                sales: result.data,
                labels: dataSet.labels,
                dataSetsBarChart,
                dataSetsLineChart,
                isFetching: false,
            })
        } catch (e) {
            console.error(e)
            throw e
        }
    }

    sortData = sales => {
        let labels = []
        let salesQuantity = []
        let soldItemsQuantity = []
        let totals = [[]]
        sales.forEach(sale => {
            labels.push(sale.month.toUpperCase())
            salesQuantity.push(sale.number_sales)
            soldItemsQuantity.push(sale.number_itens_sales)
            totals[0].push(sale.total)
        })

        return { labels, salesQuantity, soldItemsQuantity, totals }
    }

    buildDataSets = (labels, dataList, backgroundColorList) => {
        let dataSet = labels.map((label, index) => {
            let obj = {
                label: label,
                data: dataList[index],
                backgroundColor: backgroundColorList[index],
            }

            return obj
        })
        return dataSet
    }

    render() {
        const { labels, dataSetsBarChart, dataSetsLineChart, isFetching } = this.state
        return (
            <React.Fragment>
                <Row>
                    <Col sm="12" lg="6">
                        <Card>
                            {isFetching ? (
                                <div className={'sales-report--centralize-component'}>
                                    <ActivityIndicator />
                                </div>
                            ) : (
                                <ChartComponent type={'bar'} labels={labels} dataSets={dataSetsBarChart} />
                            )}
                        </Card>
                        &nbsp;
                    </Col>
                    <Col sm="12" lg="6">
                        <Card>
                            {isFetching ? (
                                <div className={'sales-report--centralize-component'}>
                                    <ActivityIndicator />
                                </div>
                            ) : (
                                <ChartComponent type={'line'} labels={labels} dataSets={dataSetsLineChart} />
                            )}
                        </Card>
                    </Col>
                </Row>
                &nbsp;
                <Card className={'sales-report--padding-card'}>
                    {isFetching ? (
                        <div className={'sales-report--centralize-component'}>
                            <ActivityIndicator />
                        </div>
                    ) : (
                        <ListGroup flush>
                            <ListGroupItemHeading className={'sales-report--background-head'} tag={'h6'}>
                                <Row className={'sales-report--head-height sales-report--line-no-margin'}>
                                    <Col className={'sales-report--text-position-end'} sm="3" lg="3">
                                        Período
                                    </Col>

                                    <Col className={'sales-report--text-position-end'} sm="3" lg="3">
                                        No. Vendas
                                    </Col>
                                    <Col className={'sales-report--text-position-end'} sm="3" lg="3">
                                        Qtd. Itens Vendidos
                                    </Col>
                                    <Col
                                        className={'sales-report--text-position-end sales-report--padding-right3'}
                                        sm="3"
                                        lg="3"
                                    >
                                        Valor de Vendas (R$)
                                    </Col>
                                </Row>
                            </ListGroupItemHeading>

                            {this.state.sales.map((sale, index) => (
                                <ListGroupItemText
                                    tag={'h6'}
                                    key={`sales_report_${index}`}
                                    className={'sales-report--line-no-margin'}
                                >
                                    <Row
                                        className={`sales-report--head-height  sales-report--line-no-margin ${
                                            index % 2 === 0 ? 'sales-report--dark-line' : 'sales-report--light-line'
                                        }`}
                                    >
                                        <Col
                                            className={'sales-report--text-position-end sales-report--letter-space'}
                                            sm="3"
                                            lg="3"
                                        >
                                            {sale.month}
                                        </Col>
                                        <Col className={'sales-report--text-position-end'} sm="3" lg="3">
                                            {sale.number_sales}
                                        </Col>
                                        <Col className={'sales-report--text-position-end'} sm="3" lg="3">
                                            {sale.number_itens_sales}
                                        </Col>
                                        <Col
                                            className={'sales-report--text-position-end sales-report--padding-right3'}
                                            sm="3"
                                            lg="3"
                                        >
                                            {sale.total}
                                        </Col>
                                    </Row>
                                </ListGroupItemText>
                            ))}
                        </ListGroup>
                    )}
                </Card>
            </React.Fragment>
        )
    }
}
